export default __webpack_public_path__ + "static/remotasks-dab8a3bf37eda0cb82c5f68bdef2fd95.png";